import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DashboardUserList from './List';
import DashboardUserDetails from './Details';
import EditDashboardUser from './Edit';
import NewDashboardUser from './New';
import { matchType } from '../../../propTypes';
import './style.less';

function DashboardUsers({ match }) {
  return (
    <Switch>
      <Route path={`${match.path}/new`} component={NewDashboardUser} />
      <Route path={`${match.path}/:id/edit`} component={EditDashboardUser} />
      <Route path={`${match.path}/:id`} component={DashboardUserDetails} />
      <Route path={`${match.path}`} component={DashboardUserList} />
    </Switch>
  );
}

DashboardUsers.propTypes = {
  match: matchType.isRequired,
};

export default DashboardUsers;
